import React, { Fragment, useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { Formik, Form } from "formik";
import * as Yup from "yup";

import { Input, SelectBoolean, SelectUsageLimitType } from "../../FormControls";
import { FormMode } from "../../../constant";

const validationSchema = Yup.object().shape({
  duration: Yup.number()
    .integer("Duration must be a number.")
    .typeError("Duration must be a number.")
    .required("Duration is required."),
  usageLimit: Yup.number()
    .integer("Usage Limit must be a number.")
    .typeError("Usage Limit must be a number.")
    .required("Usage Limit is required."),
  numberOfUnlock: Yup.number()
    .integer("Number of Unlock must be a number.")
    .typeError("Number of Unlock must be a number.")
    .min(0, "Number of Unlock cannot be less than 0.")
    .required("Number of Unlock is required."),
});

export function VoucherFormModal({
  show,
  formMode,
  initialValues,
  hasOverridePermission,
  onFormSubmit,
  onModalClose,
}) {
  const form = useForm(formMode);

  const voucherSettings = hasOverridePermission?
    // Enable fields if user has override permission
    <Col sm={6}>
      <SelectUsageLimitType
        col={6}
        labelCol={4}
      />
      <Input
        name="numberOfUnlock"
        label={{ col: 4, text: "Number of Unlock" }}
        col={6}
        type={"number"}
      />
      <SelectBoolean
        name="requiresLogin"
        labelText="Requires Login"
        col={6}
        labelCol={4}
      />
      <SelectBoolean
        name="requiresOnline"
        labelText="Requires Online"
        col={6}
        labelCol={4}
      />
    </Col>
    :
    // Disable fields if user does not have override permission
    <Col sm={6}>
      <Input
        name="usageLimitType"
        label={{ col: 4, text: "Usage Limit Type" }}
        col={6}
        disabled
      />
      <Input
        name="numberOfUnlock"
        label={{ col: 4, text: "Number of Unlock" }}
        col={6}
        disabled
      />
      <Input
        name="requiresLogin"
        label={{ col: 4, text: "Requires Login" }}
        col={6}
        disabled
      />
      <Input
        name="requiresOnline"
        label={{ col: 4, text: "Requires Online" }}
        col={6}
        disabled
      />
    </Col>

  return (
    <Modal show={show} onHide={onModalClose} bsSize="large" backdrop="static">
      <Modal.Header>
        <Modal.Title>{form.title}</Modal.Title>
      </Modal.Header>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onFormSubmit}
      >
        {({ handleSubmit, isSubmitting }) => (
          <Fragment>
            <Modal.Body>
              <Form className="form-horizontal">
                <dl className="dl-horizontal">
                  <dt>Family</dt>
                  <dd>{initialValues.family}</dd>

                  <dt>Package Name</dt>
                  <dd>{initialValues.packageName}</dd>

                  <dt>Product Number</dt>
                  <dd>{initialValues.productNumber}</dd>
                </dl>
                <hr />
                <Row>
                  <Col sm={6}>
                    <Input
                      name="duration"
                      label={{ col: 4, text: "Duration" }}
                      col={5}
                    />
                    <Input
                      name="usageLimit"
                      label={{ col: 4, text: "Usage Limit" }}
                      col={5}
                    />
                  </Col>
                  {voucherSettings}
                </Row>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <div className="btn-toolbar pull-right">
                <button
                  className="btn btn-grey"
                  onClick={onModalClose}
                  disabled={isSubmitting}
                >
                  Close
                </button>
                <Button bsStyle="primary" onClick={handleSubmit}>
                  Save {isSubmitting && <i className="fa fa-spinner fa-spin" />}
                </Button>
              </div>
            </Modal.Footer>
          </Fragment>
        )}
      </Formik>
    </Modal>
  );
}

function useForm(formMode) {
  const [title, setTitle] = useState("Define Voucher");

  useEffect(() => {
    if (formMode === FormMode.Add) {
      setTitle("Define Voucher");
    } else if (formMode === FormMode.Edit) {
      setTitle("Edit Voucher");
    }
  }, [formMode]);

  return { title };
}
